import { render, staticRenderFns } from "./PhoneTaskDetailView.vue?vue&type=template&id=f37db4d6&scoped=true"
import script from "./PhoneTaskDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneTaskDetailView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PhoneTaskDetailView.vue?vue&type=style&index=0&id=f37db4d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37db4d6",
  null
  
)

export default component.exports